import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlineRounded";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import OpenInFullRoundedIcon from "@mui/icons-material/OpenInFullRounded";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { Box, IconButton, ListItemText, Stack, Tooltip } from "@mui/material";
import { Link } from "react-router";
import { MenuItemStyled } from "@entrilia/shared/components/MenuItemStyled";
import type { Tile } from "../../../../api/types/dashboardsTypes";
import MenuIconButton from "../components/MenuIconButton";
import { useDashboardContext } from "../contexts/DashboardContext";

interface Props {
  showMaximizeButton: boolean | undefined;
  showEdit: boolean;
  showDelete: boolean;
  tile: Tile;
  onOpenFullscreen: (() => void) | undefined;
  onDeleteTile: () => void;
}

const TileHeaderMenu = ({ showMaximizeButton, showEdit, showDelete, tile, onOpenFullscreen, onDeleteTile }: Props) => {
  const { createEditTileUrl } = useDashboardContext();

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => event.stopPropagation();

  return (
    <Stack direction="row" useFlexGap spacing={0.5} sx={{ alignItems: "center" }}>
      {showMaximizeButton && (
        <Tooltip title="Open in full screen" placement="bottom" arrow disableInteractive>
          <IconButton onClick={onOpenFullscreen}>
            <OpenInFullRoundedIcon />
          </IconButton>
        </Tooltip>
      )}
      {showEdit && (
        <Tooltip title="Edit" placement="bottom" arrow disableInteractive>
          <Link to={createEditTileUrl(tile.tileId)}>
            <IconButton>
              <SettingsOutlinedIcon />
            </IconButton>
          </Link>
        </Tooltip>
      )}
      {showDelete && (
        <Box onClick={handleMenuClick}>
          <MenuIconButton icon={<MoreHorizOutlinedIcon />}>
            <MenuItemStyled onClick={onDeleteTile} sx={{ gap: 1 }}>
              <DeleteOutlineIcon fontSize="small" color="error" />
              <ListItemText>Delete</ListItemText>
            </MenuItemStyled>
          </MenuIconButton>
        </Box>
      )}
    </Stack>
  );
};

export default TileHeaderMenu;
